<template>
  <div class="state-code-select-component">
    <!--显示本地-->
    <Input v-if="state_code && (!states||states.length==0)"
           :value="'+' + state_code" readonly
           style="max-width: 100%;" :style="'width:'+width"
           prefix="ios-globe"
           @on-focus="loadStates"
           :placeholder="$attrs.placeholder"/>
    <!--可选择-->
    <Select v-else v-model="state_code"
            style="max-width: 100%;" :style="'width:'+width"
            @on-open-change="onOpen" class="state-code-select"
            @on-change="onChange"
            :placeholder="$attrs.placeholder"
            filterable clearable prefix="ios-globe">
      <OptionGroup v-for="(i,key) in states" :label="key" :key="key">
        <Option v-for="item in i" :value="item.state_code"
                :label="item.country + ' +' + item.state_code"
                :key="item.short_name">{{ item.country + ' +' + item.state_code }}<span
          style="display: none">{{ key + item.short_name }}</span></Option>
      </OptionGroup>
    </Select>
  </div>
</template>

<script>
    export default {
        name: 'SCodeSelect',
        props: {
            value: String,
            width: String,
            prepared: Boolean
        },
        data () {
            return {
                loading: false,
                states: null,
                state_code: ''
            }
        },
        watch: {
            value (val) {
                this.state_code = val;
            }
        },
        methods: {
            onOpen (flag) {
                if (!flag || this.loading) {
                    return;
                }
                if (!this.$store.state.states) {
                    this.loadStates();
                }
            },
            onChange (val) {
                this.$emit('input', val);
            },
            loadStates () {
                this.loading = true;
                this.$store.dispatch('loadStates')
                    .then((states) => {
                        this.states = states;
                    }).catch(() => {
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        },
        mounted () {
            this.state_code = this.value;
        },
        created () {
            if (this.$store.state.states) {
                this.states = this.$store.state.states;
            } else if (this.prepared) {
                this.loadStates();
            }
        }
    }
</script>

<style lang="scss" scoped>
  .state-code-select-component {
    .state-code-select {
      text-align: left;
    }
  }
</style>
